import StrainScience from "./StrainScience";

export default StrainScience;
